<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="copyright-information">
<p style="text-align: center; padding-top:170px;"><strong><em>“Toute Pensée émet un Coup de Dés.”</em></strong></p>
<p style="text-align: right;"><em>—Stéphane Mallarmé</em></p>
<p style="text-align: center;"><strong><em>“All Thought casts one Toss of the Dice.”</em></strong></p>
<p style="text-align: right;"><em>—J.D. McClatchy (tr.)</em></p>
<p><em><br/>
</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?d066ae16